import styled from '@emotion/styled';
import { Paper } from '@mui/material';

export const CardContainer = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)}
    ${(props) => props.theme.spacing(10)};
  padding-bottom: ${(props) => props.theme.spacing(10)};
`;
